import { useContext, useState } from "react";
import StatusDot from "../../../../../Components/status_dot";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VisibilityIcon from "@material-ui/icons/Visibility";
import User from "../../../../../Images/demo_client_new_logo.png";
import { MIContext } from "./MIContext";
import MIStyles from "./MIStyles";
import { useHistory } from "react-router";
import { Box } from "@material-ui/core";
import CoachNameRender from "./RenderComponents/CoachNameRender";
import { useSelector } from "react-redux";
import { title } from "process";
import CoacheeNameRender from "./RenderComponents/CoacheeNameRender";
const InitialColumns = [
  {
    title: "Coachee name",
    headerStyle: {
      background: "white",
      position: "sticky",
      left: 0,
      zIndex: 20,
    },

    cellStyle: {
      position: "sticky",
      left: 0,
      zIndex: 1,
      background: "white",
      width: "148px",
      minWidth: "148px",
    },
    field: "coachee_name",

    customSort: (a, b) =>
      a.coachee_name !== null &&
      b.coachee_name !== null &&
      a.coachee_name.localeCompare(b.coachee_name),
  },
  {
    title: "Coach name",
    field: "coach_name",
    customSort: (a, b) =>
      a.coach_name !== null &&
      b.coach_name !== null &&
      a.coach_name.localeCompare(b.coach_name),
    emptyValue: "-",
    headerStyle: {
      background: "white",
      position: "sticky",
      left: 180,
      zIndex: 20,
    },
    cellStyle: {
      position: "sticky",
      left: 180,
      zIndex: 1,
      background: "white",
      width: "148px",
      minWidth: "148px",
    },
  },
  {
    title: "Client name",
    field: "organisation_name",
    customSort: (a, b) =>
      a.organisation_name.localeCompare(b.organisation_name),
    // hiddenByColumnsButton: true,
    // removable: true,
    headerStyle: {
      background: "white",
      position: "sticky",
      left: 360,
      zIndex: 20,
    },
    cellStyle: {
      position: "sticky",
      // left: 300,
      left: 360,
      width: "148px",
      minWidth: "148px",
      zIndex: 1,
      background: "white",
    },
  },

  {
    title: "Assignment status",
    field: "status",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Final Coaching Agreement /Contract received date",
    field: "final_CA_received",
    emptyValue: "-",
    sorting: false,
  },

  {
    title: "Fiscal year",
    field: "fiscal_year",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Date of request",
    field: "date_of_request",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Date of acknowledgement",
    field: "date_of_acknowledgement",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Coachee Request Form received date",
    field: "coachee_request_form_received_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Coachee Request Form acknowledgement date",
    field: "coachee_request_form_acknowledgement_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Pre Questionnaire Form acknowledgement date",
    field: "pre_questionnaire_form_acknowledgement_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Pre Questionnaire Form received date",
    field: "pre_questionnaire_form_received_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Pre Questionnaire Form sent date",
    field: "pre_questionnaire_form_sent_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Total Hours Agreed",
    field: "number_of_hours",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "360 Requested Y/N",
    field: "requested_360",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Client 360 to be used Y/N",
    field: "client_360_to_be_used",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Pre Questionnaire to be used Y/N",
    field: "pre_questionnaire_to_be_used",
    emptyValue: "-",
    sorting: false,
  },

  {
    title: "Email address",
    field: "email_address",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Email after midpoint",
    field: "email_after_midpoint",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Verbal 360 Stakeholder Costs",
    field: "verbal_360_stakeholder_cost",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Assessment Costs",
    field: "assessment_cost",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Assignment status",
    field: "assignment_status",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Verbal 360 Stakeholder Costs GBP",
    field: "verbal_360_stakeholder_costs_gbp",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Assessment Costs GBP",
    field: "assessment_costs_gbp",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Psychometrics cost GBP",
    field: "psycometric_costs_gbp",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Other Costs GBP",
    field: "other_costs_gbp",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Client Review date/s",
    field: "client_review_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Extension notes",
    field: "extension_notes",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Internal Comments",
    field: "internal_comments",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Date of briefing call",
    field: "date_of_briefing_call",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Total Program Costs",
    field: "total_program_costs",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Total Program Costs GBP",
    field: "total_program_costs_gbp",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Other Costs",
    field: "other_cost",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "PO Number",
    field: "po_number",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Region",
    field: "region",
    emptyValue: "-",
    sorting: false,
  },
  {
    title:
      "Department/Office/ Division/ Business/Function/Global Business/ Unit/Team/Parent Division/Sub Division/Op Co/Business Area",
    field: "business_area",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Chemistry rapport session date",
    field: "chemistry_rapport_meeting_dates",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Verbal 360 Stakeholder Interviews Completed Y/N",
    field: "verbal_360_stakeholder_interviews_completed",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Psychometrics Used (if applicable)",
    field: "psychometrics_used",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Contracting Session",
    field: "contracting_session",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Line manager call",
    field: "line_manager_call",
    emptyValue: "-",
    sorting: false,
  },

  {
    title: "1st Coaching session",
    field: "coaching_session_1st",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Choice of Coach Email",
    field: "choice_of_coach_email",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "2nd Coaching session",
    field: "coaching_session_2nd",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "3rd Coaching session",
    field: "coaching_session_3rd",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Interim review",
    field: "interim_review",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "4th Coaching session  (60-90 mins)",
    field: "coaching_session_4th",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "5th Coaching session (60-90 mins)",
    field: "coaching_session_5th",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "6th Coaching session (60-90 mins)",
    field: "coaching_session_6th",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "7th Coaching session (60-90 mins)",
    field: "coaching_session_7th",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "8th Coaching session",
    field: "coaching_session_8th",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "9th Coaching session",
    field: "coaching_session_9th",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "10th Coaching session",
    field: "coaching_session_10th",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "11th Coaching session",
    field: "coaching_session_11th",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "12th Coaching session",
    field: "coaching_session_12th",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "13th Coaching session",
    field: "coaching_session_13th",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "14th Coaching session",
    field: "coaching_session_14th",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Completion session",
    field: "completion_session",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Evaluation and Closure session",
    field: "evaluation_and_closure_session",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Evaluation form sent date",
    field: "evaluation_form_sent_date",
    emptyValue: "-",
    sorting: false,
  },

  {
    title: "Optional Comments - coach",
    field: "optional_comments_coach",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Initial Coaching Agreement/ Contract Received date",
    field: "initial_coaching_agreement_contract_received_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Final Coaching Agreement /Contract received date",
    field: "final_coaching_agreement_contract_received_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Expected assignment duration",
    field: "expected_assignment_duration",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "QA call request",
    field: "qa_call_request",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "QA Call date",
    field: "qa_call_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "QA Feedback Text",
    field: "qa_feedback_text",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Hours Coached",
    field: "hours_coached",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Total Hours Agreed",
    field: "total_hours_agreed",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Total Hours used to date",
    field: "total_hours_used_to_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Hours left to deliver",
    field: "hours_left_to_deliver",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Details of cancelled Sessions",
    field: "details_of_cancelled_sessions",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Total amount in currency",
    field: "total_amount_in_currency",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Total amount in GBP",
    field: "total_amount_in_GBP",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Invoice date",
    field: "invoice_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Due date",
    field: "due_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Promised date",
    field: "promised_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Paid date",
    field: "paid_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Anticipated date",
    field: "anticipated_date",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Invoice status",
    field: "invoice_status",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Invoice notes",
    field: "invoice_notes",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "1st Tranche invoicing amount",
    field: "tranche_invoicing_amount_1st",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "1st Tranche amount in GBP",
    field: "tranche_amount_in_GBP_1st",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "1st Tranche anticpated invoice payment date",
    field: "tranche_anticpated_invoice_payment_date_1st",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "1st Tranche Invoice date",
    field: "tranche_invoice_date_1st",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "1st Tranche invoice payment date",
    field: "tranche_invoice_payment_date_1st",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "2nd Tranche invoicing amount",
    field: "tranche_invoicing_amount_2nd",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "2nd Tranche amount in GBP",
    field: "tranche_amount_in_GBP_2nd",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "2nd Tranche anticpated invoice payment date",
    field: "tranche_anticipated_invoice_payment_date_2nd",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "2nd Tranche Invoice date",
    field: "tranche_invoice_date_2nd",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "2nd Tranche invoice payment date",
    field: "tranche_invoice_payment_date_2nd",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "3rd Tranche invoicing amount",
    field: "tranche_invoicing_amount_3rd",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "3rd Tranche amount in GBP",
    field: "tranche_amount_in_GBP_3rd",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "3rd Tranche anticpated invoice payment date",
    field: "tranche_anticipated_invoice_payment_date_3rd",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "3rd Tranche Invoice date",
    field: "tranche_invoice_date_3rd",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "3rd Tranche invoice payment date",
    field: "tranche_invoice_payment_date_3rd",
    emptyValue: "-",
    sorting: false,
  },

  {
    title: "Program name (type)",
    field: "programme_type",
    customSort: (a, b) => a.programme_type.localeCompare(b.programme_type),
    hiddenByColumnsButton: true,
    removable: true,
  },

  {
    title: "Account manager",
    field: "account_manager",
    hidden: true,
    sorting: false,
  },
  {
    title: "Number of Hrs",
    field: "number_of_hour",
    hidden: true,
    sorting: false,
  },
  {
    title: "Number of sessions",
    field: "number_of_sessions",
    hidden: true,
    sorting: false,
  },
  {
    title: "PA/Assistant (Name)",
    field: "pa_name",
    hidden: true,
    sorting: false,
  },
  {
    title: "PA/Assistant (contacts) ",
    field: "pa_contact_details",
    hidden: true,
    sorting: false,
  },
  {
    title: "LOB Leader",
    field: "lob_leader_name",
    hidden: true,
    sorting: false,
  },
  {
    title: "Account director",
    field: "account_director",
    hidden: true,
    sorting: false,
  },
  {
    title: "Name of HRBP",
    field: "HRBP_name",
    hidden: true,
    sorting: false,
  },
  {
    title: "Line Manager",
    field: "line_manager",
    hidden: true,
    sorting: false,
  },
  {
    title: "Evaluation form",
    field: "evaluation_form",
    hidden: true,
    sorting: false,
  },
  {
    title: "Delivery duration",
    field: "delivery_duration",
    hidden: true,
    sorting: false,
  },
  {
    title: "Client sponsor",
    field: "client_sponsor",
    hidden: true,
    sorting: false,
  },
  {
    title: " Date of next session",
    field: "date_of_next_session",
    hidden: true,
    sorting: false,
  },
  {
    title: "Date assignment received",
    field: "date_received",
    hidden: true,
    sorting: false,
  },
  {
    title: "Location",
    field: "location",
    // hidden: true,
    customSort: (a, b) => a.location.localeCompare(b.location),
  },
  {
    title: "Unit",
    field: "unit",
    hidden: true,
    sorting: false,
  },
  {
    title: "Email",
    field: "email",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },
  {
    title: "Title",
    field: "title",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "First session date",
    field: "first_session_date",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },
  {
    title: "Last session date",
    field: "last_session_date",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },
  {
    title: "Date of briefing call",
    field: "briefing_call",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },
  {
    title: "Agency",
    field: "agency",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },
  {
    title: "Bank ID ",
    field: "bank_id",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },
  {
    title: "Cost centre",
    field: "cost_centre",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },
  {
    title: "Estimated completion date",
    field: "estimated_completion_date",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },
  {
    title: "Length of programme",
    field: "length_of_programme",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },
  {
    title: "Coachee first name",
    field: "first_name_coachee",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },
  {
    title: "Coachee last name",
    field: "last_name_coachee",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },
  {
    title: "Band/Level/Grade",
    field: "level_structure",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },
  {
    title: "Coaches proposed",
    field: "coaches_proposed",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },

  {
    title: "Coach Selected",
    field: "coach_selected",
    sorting: false,
  },

  {
    title: "Virtual/ Face to Face/Hybrid",
    field: "virtual_or_face",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Service type",
    field: "service_type",
    emptyValue: "-",
    sorting: false,
  },
  { title: "Service", field: "service", emptyValue: "-", hidden: true },
  {
    title: "Shortlist feedback",
    field: "shortlist_feedback",
    sorting: false,
    // emptyValue: '-',
    hidden: true,
  },
  {
    title: "Chemistry/Rapport meeting dates",
    field: "chemistry_meeting_details",
    emptyValue: "-",
    hidden: true,
    sorting: false,
  },
  // {
  //   title: "Chemistry/ Rapport request Feedback",
  //   field: "chemistry_meeting_details",
  //   emptyValue: "-",
  //   hidden: true,
  //   sorting: false,
  // },

  {
    title: "Chemistry/Rapport client feedback",
    field: "chemistry_meeting_details_client",
    sorting: false,
    hidden: true,
    // emptyValue: '-',
    // hidden: true,
  },
  {
    title: "Hogan certified",
    field: "hogan_certified",
    emptyValue: "-",
    sorting: false,
    hidden: true,
  },
  {
    title: "Coordinator notes",
    field: "coordinator_notes",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Coordinator follow up date",
    field: "coordinator_follow_up_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Account Coordinator",
    field: "account_coordinator",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Reminder shortlist to coachee/HR",
    field: "reminder_shortlist_to_coachee_hr",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Unsuccessful selection for chemistry",
    field: "unsuccessful_selection_for_chemsitry",
    emptyValue: "-",
    sorting: false,
  },
  {
    title: "Successful selection for chemistry",
    field: "successful_selection_for_chemistry",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Chemistry Rapport Coach request Feedback",
    field: "chemistry_rapport_coach_request_feedback",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Chemistry Rapport Client Feedback",
    field: "chemistry_rapport_client_feedback",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Unsuccessful selection from chemistry",
    field: "unsuccessful_selection_from_chemsitry",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Confirmation emails sent dates for all stakeholders",
    field: "confirmation_emails_sent_dates_for_all_stakeholders",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Verbal 360 Stakeholder Interview names and dates of interviews",
    field: "verbal_360_stakeholder_interview_names_and_dates_of_interviews",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Hogan initiated with APS date",
    field: "hogan_initiated_with_aps_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Hogan Status completed Y/N",
    field: "hogan_status_completed",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Hogan Assessment Debrief Y/N",
    field: "hogan_assessment_debrief",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Hogan Assessment Debrief date",
    field: "hogan_assessment_debrief_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "APS debrief with the Coach",
    field: "aps_debrief_with_the_coach",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Psychometrics cost (if applicable)",
    field: "psychometrics_cost",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Psychometrics Used Approval email",
    field: "psychometrics_used_approval_email",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Psychometrics Used Approval",
    field: "psychometrics_used_approval",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Review form sent date",
    field: "review_form_sent_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Review form acknowledgment sent date",
    field: "review_form_acknowledgment_sent_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Review questionnaire Coachee/LM/Coach",
    field: "review_questionnaire_coachee_lm_coach",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Approval to continue following Review",
    field: "approval_to_continue_following_review",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Email before penultimate session",
    field: "email_before_penultimate_session",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Wrap up session",
    field: "wrap_up_session",
    emptyValue: "-",
    hidden: true,
  },

  {
    title: "Evaluation form acknowledgment sent date",
    field: "evaluation_form_acknowledgment_sent_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Request completion of the Initial Coaching Agreement",
    field: "request_completion_of_the_initial_coaching_agreement",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Request completion of the Final Coaching Agreement",
    field: "request_completion_of_the_final_coaching_agreement",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Organizational Metric Objective 1",
    field: "leadership_competency_objective_1",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Organizational Metric Objective 2",
    field: "leadership_competency_objective_2",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Organizational Metric Objective 3",
    field: "leadership_competency_objective_3",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Objective 1",
    field: "objective_1",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Objective 2",
    field: "objective_2",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Objective 3",
    field: "objective_3",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Extension request from Coach Coach date",
    field: "extension_request_from_coach_coach_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Extension request Coachee Coach date",
    field: "extension_request_coachee_coach_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Extension request HR/LM/Programme Manager Coach date",
    field: "extension_request_hr_lm_programme_manage_coach_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title:
      "Extension request HR/LM/Programme Manager acknowledgement Coach date",
    field:
      "extension_request_hr_lm_programme_manager_acknowledgement_coach_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Extension business case received and logged",
    field: "extension_business_case_received_and_logged",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Extension request from Coach acknowledgement Coach date",
    field: "extension_request_from_coach_acknowledgement_coach_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Extension request Coachee acknowledgement Coach date",
    field: "extension_request_coachee_acknowledgement_coach_date",
    emptyValue: "-",
    hidden: true,
  },
  // {
  //   title:
  //     "Extension request HR/LM/Programme Manager acknowledgement Coach date",
  //   field:
  //     "extension_request_hr_lm_programme_manager_acknowledgement_coach_date",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  {
    title: "Approval to continue",
    field: "approval_to_continue",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Approval to continue to Coach",
    field: "approval_to_continue_to_coach",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Approval to continue to Coachee",
    field: "approval_to_continue_to_coachee",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Request to continue coaching following Review",
    field: "request_to_continue_coaching_following_review",
    emptyValue: "-",
    hidden: true,
  },
  // {
  //   title: "Internal Comments",
  //   field: "internal_comments",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  {
    title: "Hours used this Period",
    field: "hours_used_this_period",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Work Release done Y/N",
    field: "work_release_done",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Invoicing process requested date",
    field: "invoicing_process_requested_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Payment terms",
    field: "payment_terms",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "PO received date",
    field: "po_received_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "PO requested date",
    field: "po_requested_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "No of sessions invoices with latest invoice date per quarter",
    field: "No_of_sessions_invoices_with_latest_invoice_date_per_quarter",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "MI sent date",
    field: "mi_sent_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Review of Coaching Pool 6 monthly Y/N plus date",
    field: "review_of_coaching_pool_6_monthly_plus_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Invoicing process received date",
    field: "invoicing_process_received_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Coaching Initiation received date ",
    field: "coaching_initiation_received_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Coaching Initiation acknowledgement date ",
    field: "coaching_initiation_acknowledgement_date",
    emptyValue: "-",
    hidden: true,
  },

  // {
  //   title: "Programme name",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },

  // {
  //   title: "Estimated Completion Date ",
  //   field: "estimated_completion_date",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  {
    title: "Date of 360 Approval email to client",
    field: "date_of_360_approval_email_to_client",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Date of 360 Approval email from client",
    field: "date_of_360_approval_email_from_client",
    emptyValue: "-",
    hidden: true,
  },

  {
    title: "Hogan Requested Y/N",
    field: "hogan_requested",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Coaches Contacted date",
    field: "coache_contacted_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Short List Sent date ",
    field: "short_list_sent_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Coachee availability date",
    field: "coachee_availability_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Coachee availability acknowledgement email date",
    field: "coachee_availability_acknowledgement_email_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Coachee availability received date",
    field: "coachee_availability_received_date",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Short List Feedback",
    field: "short_list_feedback",
    emptyValue: "-",
    hidden: true,
  },

  // {
  //   title: "Confirmation emails sent dates for all stakeholders",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  {
    title: "Request Evaluation Acuity service",
    field: "request_evaluation_acuity_service",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Client 360 Completed Y/N",
    field: "client_360_completed",
    emptyValue: "-",
    hidden: true,
  },

  {
    title: "Verbal 360 Stakeholder Interviews information",
    field: "verbal_360_stakeholder_interviews_information",
    emptyValue: "-",
    hidden: true,
  },
  // {
  //   title: "Verbal 360 Stakeholder Interviews Completed Y/N",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },

  // {
  //   title: "Verbal 360 Stakeholder Interview names and dates of interviews",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Verbal 360 Stakeholder Interviews No Shows Text box",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Hogan initiated with APS date",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Hogan Status completed Y/N",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Hogan Assessment Debrief Y/N ",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Hogan Assessment Debrief date",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "APS debrief with the Coach",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Psychometrics Used (if applicable)",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Psychometrics cost (if applicable)",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },

  //  {
  //   title: "Psychometrics Used Approval email",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  //  {
  //   title: "Psychometrics Used Approval",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  //  {
  //   title: "Contracting Session",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },

  {
    title: "Kick-off Session",
    field: "kick_off_session",
    emptyValue: "-",
    hidden: true,
  },
  {
    title: "Alignment Session",
    field: "alignment_session",
    emptyValue: "-",
    hidden: true,
  },
  // {
  //   title: "Alignment Session",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Alignment Session",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Alignment Session",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Alignment Session",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Alignment Session",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Alignment Session",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Alignment Session",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  {
    title: "Email 360º Stakeholder Survey",
    field: "email_360_stakeholder_survey",
    emptyValue: "-",
    hidden: true,
  },

  // {
  //   title: "1st Coaching session",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Choice of Coach Email ",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },{
  //   title: "2nd Coaching session",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },

  // {
  //   title: "Alignment Session",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },
  // {
  //   title: "Alignment Session",
  //   field: "level_structure",
  //   emptyValue: "-",
  //   hidden: true,
  // },

  {
    title: "Assignment view",
    field: "id",
    sorting: false,

    headerStyle: {
      background: "white",
      position: "sticky",
      right: 0,
      zIndex: 20,
    },
    cellStyle: {
      position: "sticky",
      right: 0,
      zIndex: 1,
      background: "white",
    },
    width: "10%",
  },
];

const Columns = () => {
  const { setCurrentSelection, setIsFeedback, setAnchorEl } =
    useContext(MIContext);

  const classes = MIStyles();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const coacheeNameRender = (rowData) => {
    return <CoacheeNameRender rowData={rowData} />;
  };
  const shortListFeedbackRender = (rowData) => (
    <div id={`div-${rowData.id}`}>
      <IconButton
        aria-label="more"
        aria-controls={`long-menu-${rowData.id}`}
        aria-haspopup="true"
        onClick={() => {
          setIsFeedback(true);
          console.log("data feed click", rowData);
          setCurrentSelection({
            assignment_id: rowData.id,
            session_scenario_id: 1,
            title: "Shortlist feedback",
            feedBackData: rowData.shortlist_feedback,
          });
        }}
      >
        <VisibilityIcon />
      </IconButton>
    </div>
  );
  const chemistryClientRapportRender = (rowData) => (
    <div id={`div-${rowData.id}`}>
      <IconButton
        aria-label="more"
        aria-controls={`long-menu-${rowData.id}`}
        aria-haspopup="true"
        onClick={() => {
          setCurrentSelection({
            assignment_id: rowData.id,
            session_scenario_id: 2,
            title: "Chemistry/Rapport client feedback",
            feedBackData: rowData.chemistry_meeting_details_client,
          });
          setIsFeedback(true);
        }}
      >
        <VisibilityIcon />
      </IconButton>
    </div>
  );
  const actionsRender = (rowData) => (
    <div id={`div-${rowData.id}`}>
      <IconButton
        className={classes.textSecondary}
        aria-label="more"
        aria-controls={`long-menu-${rowData.id}`}
        aria-haspopup="true"
        onClick={(e) => {
          setCurrentSelection(rowData);
          handleClick(e);
          console.log(e, "original args");
        }}
      >
        <MoreVertIcon />
      </IconButton>
    </div>
  );
  const coachNameRender = (rowData) => {
    return <CoachNameRender rowData={rowData} />;
  };
  const totalCostRender = (rowData) => {
    const [currency, amount] = rowData?.total_programme_cost?.split(" ");
    return (
      <Box
        width={"120px"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography style={{ textAlign: "left" }}>{currency}</Typography>
        <Typography style={{ textAlign: "right" }}>{amount}</Typography>
      </Box>
    );
  };
  const finalColumns = InitialColumns.map((el) => {
    if (el.title === "Coachee name") {
      return { ...el, render: coacheeNameRender };
    }
    if (el.title === "Coach name") {
      return {
        ...el,
        render: coachNameRender,
      };
    }
    if (el.title === "Assignment view") {
      return { ...el, render: actionsRender };
    }
    if (el.title === "Shortlist feedback") {
      return { ...el, render: shortListFeedbackRender };
    }
    if (el.title === "Chemistry/Rapport client feedback") {
      return { ...el, render: chemistryClientRapportRender };
    }
    if (el.title === "Total program cost") {
      return { ...el, render: totalCostRender };
    }
    return el;
  });

  return finalColumns;
};

export default Columns;
